export { default } from './Page';



// WEBPACK FOOTER //
// ./src/components/Page/index.js